import React from "react";
import { useUserPnL } from "../../../../context/DataManagerContext";
import ProfitStatus from "./ContentPresenter";

const ContentContainer = () => {
  const { userPnLData, sumData, isDataReady } = useUserPnL();

  if (!isDataReady) {
    return (
      <div className="h-full flex items-center justify-center text-muted-foreground">
        데이터 로딩 중...
      </div>
    );
  }

  return (
    <div className="h-full">
      <ProfitStatus data={userPnLData} sum={sumData} />
    </div>
  );
};

export default ContentContainer;
